/* global bocAmchart4 */

/**
 * Array of the ids for the amcharts to debug e.g. 'amchart1' etc. for local debugging
 * @type {[string]}
 */
bocAmchart4.bocDebugIds = [];

if (!window.hasOwnProperty('jsErrors')) {
    window.jsErrors = [];
    window.onerror = function (error, url, line) {
        window.jsErrors.push(error + ". Line: " + line);
    };
}

/**
 * Check if this request should be debug output to console based on shortcode or above list
 * @param {AMConfig} chartSettings The chart options
 * @returns {boolean} should it debug?
 */
bocAmchart4.debug = function (chartSettings) {
    var fromShortcode = chartSettings.hasOwnProperty("bocSettings")
        && chartSettings.bocSettings.hasOwnProperty("args")
        && chartSettings.bocSettings.args.debug === "true";

    var fromAbove = chartSettings.hasOwnProperty("bocSettings")
        && bocAmchart4.bocDebugIds.indexOf(chartSettings.bocSettings.id) > -1;

    return fromShortcode || fromAbove;
};

/**
 * Helper function to make a clone of the object to avoid getting evergreen console output
 * @param {AMConfig} arg any object (probably AMCharts related)
 * @returns {object} clone with recursive object replaced by strings
 */
bocAmchart4.debugClone = function (arg) {
    var lastKey = '';
    var recursiveKeys = [
        "object",
        "_parent",
        "_topParent",
        "_virtualParent",
        "context",
        "target",
        "sprite",
        "component",
        "_sprite",
        "_value",
        "clonedFrom",
        "0",
        "_container",
        "_axis",
        "dataProvider",
        "_chart",
        "_component",
        "scope",
        "series",
        "chart",
        "_dataItem",
        "axis",
        "_baseAxis",
        "_menu"
    ];
    try {
        return JSON.parse(
            JSON.stringify(
                arg,
                function (key, value) {
                    if (recursiveKeys.indexOf(key) > -1 && typeof value === 'object') {
                        return "Reference to '" + key + "' object";
                    } else {
                        lastKey = key;
                        return value;
                    }
                }
            )
        );
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
    }
    // eslint-disable-next-line no-console
    console.log("Failed to clone the object, recursive key: " + lastKey);
    return arg;
};
